<template>
  <v-container>
    <v-data-table
      :headers="rcpt_headers"
      :items="rcpt_items"
      class="elevation-1"
      :loading="rcptLoading"
      loading-text="Загружаю данные"
      item-key="ULF_UUID"
      show-select
      single-select
      :search="rcptSearch"
      :value="value"
      @input="setValue"
      locale="ru-RU"
      dense
    >
      <template v-slot:top>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Конфигурации</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="rcptSearch"
            append-icon="mdi-magnify"
            label="Искать"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        Нет данных
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { RCPT_GET_RECEPTURES_LIST } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  emits: ['input'],
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  name: 'recepturesTable',
  components: {
  },
  data () {
    return {
      rcpt_headers: [
        { text: 'Наименование', value: 'ULF_NAME' },
        { text: 'Код', value: 'ULF_CODE' },
        { text: 'Дата создания', align: 'start', value: 'ULF_CR_DATE' },
        { text: 'Создатель', value: 'USER.USR_FIO' },
        { text: 'Текущий статус', value: 'STATE.DS_NAME' }
      ],
      rcptLoading: false,
      rcptSearch: '',
      selectedRcpt: []
    }
  },
  watch: {
  },
  computed: {
    rcpt_items: {
      get: function () {
        const rcptItems = this.$store.getters.getCurrentRecepturesList
        console.log('Getting rcptItems ', rcptItems)
        return rcptItems
      }
    }
  },
  mounted: function () {
    if (this.rcpt_items.length === 0) {
      this.getRcptList()
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    },
    getRcptList () {
      this.rcptLoading = true
      this.$store.dispatch(RCPT_GET_RECEPTURES_LIST)
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка рецептур: \n ${err}` })
        })
        .finally(() => {
          this.rcptLoading = false
        })
    }
  }
}
</script>
